<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <header class="header">
      <div>
        <router-link
          style="text-decoration: none; color: black"
          :to="{ name: 'Home' }"
        >
          <h2 class="m-0 mb-1 profile-text">Onsite messaging</h2>
        </router-link>
        <Breadcrumb :model="items" class="items-text" />
      </div>
      <div class="text-right" style="display: flex">
        <PrimeButton
          label="New onsite message"
          class="save-btn"
          icon="plus-icon "
        ></PrimeButton>
      </div>
    </header>

    <!-- For Sidebar -->
    <aside></aside>

    <div>
      <section class="wrapperAdd mid-width">
        <div class="grid">
          <div class="col-12">
            <div class=":lg-col-10 flex-container">
              <div class="border-box">
                <PrimeButton
                  class="lg:col-3 desk-btn active-btn"
                  id="showall"
                  label="Show all"
                ></PrimeButton>
                <PrimeButton
                  class="lg:col-3 desk-btn"
                  id="customerDatabase"
                  label="Grow your customer database"
                ></PrimeButton>
                <PrimeButton
                  class="lg:col-3 desk-btn"
                  id="enrichDatabase"
                  label="Enrich your database"
                ></PrimeButton>
                <PrimeButton
                  class="lg:col-3 desk-btn"
                  id="reachyouraudience"
                  label="Reach out to your audience"
                ></PrimeButton>
              </div>

              <div class=":lg-col-2 arrow-buttons">
                <PrimeButton
                  class="arrow-icon"
                  icon="left-arrow-icon"
                  @click="scrollLeft"
                ></PrimeButton>
                <PrimeButton
                  class="arrow-icon"
                  icon="right-arrow-icon"
                  @click="scrollRight"
                ></PrimeButton>
              </div>
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 xl:col-6">
            <div class="grid">
              <div class="col-4">
                <section class="card1">
                  <i class="star-icon"></i>
                  <h5 class="">New product drop</h5>
                  <p>Increase your contact database</p>
                </section>
              </div>
              <div class="col-4">
                <section class="card1">
                  <i class="subscribe-icon"></i>
                  <h5 class="">Subscribe for updates</h5>
                  <p>Grow your email list and get to know yours customers</p>
                </section>
              </div>
              <div class="col-4">
                <section class="card1">
                  <i class="exit-icon"></i>
                  <h5 class="">Discount before exit</h5>
                  <p>Re-engage customers with a discount before exiting</p>
                </section>
              </div>
            </div>
          </div>
          <div class="col-12 xl:col-6">
            <div class="grid">
              <div class="col-4">
                <section class="card1">
                  <i class="shopping-icon"></i>
                  <h5 class="">Free shipping</h5>
                  <p>Grow your email list by offering free shipping</p>
                </section>
              </div>
              <div class="col-4">
                <section class="card1">
                  <i class="coupon-icon"></i>
                  <h5 class="">Subscribe for coupon</h5>
                  <p>Increase your database</p>
                </section>
              </div>
              <div class="col-4">
                <section class="card1">
                  <i class="order-icon"></i>
                  <h5 class="">First Order discount</h5>
                  <p>Grow ypur email with a discount offer</p>
                </section>
              </div>
            </div>
          </div>
        </div>

        <div class="grid graph">
          <div class="col-12 xl:col-5">
            <div class="col-12 graph2">
              <section class="card2">
                <div>
                  <span class="widget-text">Widget impressions</span>
                  <img
                    src="../../assets/images/Graph-img.png"
                    alt=""
                    class="graphing"
                  />
                </div>
                <div class="text-date">
                  <p>Apr 21</p>
                  <p>Apr 25</p>
                  <p>Apr 29</p>
                  <p>May 03</p>
                  <p>May 07</p>
                  <p>May 11</p>
                  <p>May 15</p>
                </div>
              </section>
            </div>
          </div>

          <div class="grid col-12 xl:col-7">
            <div class="col-6">
              <section class="card3">
                <span class="widget-text">Started conversations</span>
                <span class="num-text">14.593</span>
                <p class="p-text">15 june 2023- 16 june 2023</p>
                <img
                  src="../../assets/images/Graph-line.png"
                  alt=""
                  class="graphline"
                />
                <div class="line1 mt-2">
                  <PrimeButton
                    icon="up-right-icon"
                    class="liveicon"
                  ></PrimeButton>
                  <p class="p2-text ml-2">+1.5% compared to Nov 2020</p>
                </div>
              </section>
            </div>
            <div class="col-6">
              <section class="card3">
                <span class="widget-text">Total clicks</span>
                <span class="num-text">25.103</span>
                <p class="p-text">15 june 2023- 16 june 2023</p>
                <img
                  src="../../assets/images/Graph-line.png"
                  alt=""
                  class="graphline"
                />
                <div class="line1 mt-2">
                  <PrimeButton
                    icon="up-right-icon"
                    class="liveicon"
                  ></PrimeButton>
                  <p class="p2-text ml-2">+1.5% compared to Nov 2020</p>
                </div>
              </section>
            </div>
          </div>
        </div>

        <div class="lg:col-12">
          <div class="card mt-3">
            <div class="head-text">
              <i class="coupon-icon"></i>
              <p class="head-text1">12 live deals</p>
            </div>

            <DataTable
              :value="products"
              dataKey="id"
              :tableStyle="{ minWidth: '20rem' }"
            >
              <Column
                selectionMode="multiple"
                headerStyle="{ width: '3rem' }"
              ></Column>
              <Column field="chip" header="">
                <template #body="data">
                  <Chip label="Live" class="chip" />
                  <Chip
                    v-if="data.data.workingStatus == 'Offline'"
                    label="data.data.workingStatus"
                    class="text-danger chip"
                  />
                  <Chip
                    v-if="data.data.workingStatus == 'NoActivity'"
                    label="data.data.workingStatus"
                    class="text-warning chip"
                  />
                </template>
              </Column>
              <Column field="deal" header="Deal" sortable></Column>
              <Column field="site" header="Site" sortable></Column>
              <Column field="priority" header="Priority" sortable></Column>
              <Column field="language" header="Language" sortable></Column>
              <Column field="status" header="Status" sortable>
                <template #body="data">
                  <Chip label="Unpublished" class="chip2" />
                  <Chip
                    v-if="data.data.workingStatus2 == 'Published'"
                    label="data.data.workingStatus2"
                    class="text-danger chip2"
                  /> </template
              ></Column>
              <Column
                field="createddate"
                header="Created Date"
                sortable
              ></Column>
              <Column field="startdate" header="Start Date" sortable></Column>
              <Column field="enddate" header="End Date" sortable></Column>
              <Column field="tagname" header="Tag name" sortable></Column>
            </DataTable>
          </div>
        </div>
        <!-- </div> -->
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyTableComponent",
  components: {
    // DataTable,
    // Column,
    // Chips,
  },
  data() {
    return {
      vmodel: {},
      items: [{ label: "Start" }, { label: "Overview" }],
      products: [
        {
          id: 1,
          chip: "Live",
          deal: "Deal 1",
          site: "Site 1",
          priority: "High",
          language: "English",
          status: "Unpublised",
          createddate: "2024-01-01",
          startdate: "",
          enddate: "-",
          tagname: "Tag1",
        },
        {
          id: 2,
          chip: "Paused",
          deal: "Deal 2",
          site: "Site 2",
          priority: "Medium",
          language: "French",
          status: "Unpublised",
          createddate: "2024-01-02",
          startdate: "",
          enddate: "-",
          tagname: "Tag2",
        },
        {
          id: 3,
          chip: "Unpublished",
          deal: "Deal 3",
          site: "Site 3",
          priority: "Low",
          language: "Spanish",
          status: "Unpublised",
          createddate: "2024-01-03",
          startdate: "",
          enddate: "-",
          tagname: "Tag3",
        },
      ],
    };
  },

  methods: {
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      container.scrollLeft -= 100;
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      container.scrollLeft += 100;
    },

    chipTemplate(rowData) {
      return {
        render: (h) =>
          h("Chips", {
            props: {
              value: [rowData.chip],
            },
            class: this.getChipClass(rowData.chip),
          }),
      };
    },
    getChipClass(chip) {
      switch (chip.toLowerCase()) {
        case "live":
          return "chip-live";
        case "paused":
          return "chip-paused";
        case "unpublished":
          return "chip-unpublished";
        default:
          return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  -webkit-box-align: center;
  justify-content: space-between;
  align-items: center;
  // position: fixed;
  // left: 0px;
  // right: 0px;
  z-index: 1002;
  height: 80px;
  padding: 0px 15px;
  background: #fff;
  border-bottom: 1px solid #f1f2f7;
}

.h5 {
  font-family: "Voyado Text";
  font-weight: 500;
  font-size: 16px;
  line-height: 14px;
  align-items: center;
  color: #000;
}

.p {
  font-family: "Voyado Text";
  font-weight: 400;
  font-size: 14.22px;
  line-height: 17.1px;
  color: #21211f;
}

.p-text {
  font-family: "Voyado Text";
  font-weight: 400;
  font-size: 16px;
  line-height: 19.2px;
  color: #000;
}

@media screen and (min-width: 500px) and (max-width: 800px) {
   .h5 {
    font-size: 12px !important;
  }
   .p {
    font-size: 10px !important;
  }
   .p-text {
    font-size: 12px !important;
  }
}

@media (max-width: 500px) {
   .h5 {
    font-size: 10px !important;
  }
   .p {
    font-size: 8px !important;
  }
   .p-text {
    font-size: 8px !important;
  }
}
.widget-text {
  font-family: "Voyado Text";
  font-weight: 500;
  font-size: 18px;
  line-height: 21.6px;
  color: #000;
  max-width: min-content;
}
.profile-text {
  font-family: "Voyado Display" !important;
  font-size: 25.63px !important;
  font-weight: 500 !important;
  line-height: 30.76px;
  color: #000;
}

.save-btn {
  background-color: #2d6e6d;
  border-radius: 4px;
  height: 40px;
  width: auto;
  padding: 0px 16px 0px 16px;
  border-color: #2d6e6d;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  line-height: 1.5;
  box-shadow: none !important;
  top: 0px;
  font-family: "Voyado Text" !important;
}

.save-btn:hover {
  border-color: #2d6e6d !important;
  background-color: #2d6e6d !important;
  color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}

.p-button.p-button-icon-only {
  padding: 0;
}

:deep(.items-text) {
  color: #797971 !important;
  font-size: 12.64px;
  font-family: "Voyado text";
  font-weight: 400;
  line-height: 15.2px;
  background: none;
  padding: 0px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

:deep(
    .p-breadcrumb,
    .p-menuitem-text,
    .p-breadcrumb-list li,
    .p-menuitem-link
  ) {
  color: #797971 !important;
  border: 0 none;
  font-size: 12.64px;
  font-family: "Voyado text";
  font-weight: 400;
  line-height: 15.2px;
  border-radius: 4px;
  padding: 0px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

//header-css-over

:deep(.card-mid) {
  border-color: none !important;
  background: none !important;
  font-size: 1rem;
  font-weight: 400;
  padding: 0rem 0rem !important;
  margin-bottom: 0;
}

.wrapperAdd {
  margin: 0 auto;
  width: 80%;
}

.wrapperAdd.mid-width {
  // max-width: 1443px;
  max-width: auto;
}

@media screen and (max-width: 800px) {
  .wrapperAdd {
    width: 100%;
  }
}

//border-box css
.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.border-box {
  border: 1px solid #e3e3d1;
  height: 40px;
  // display: flex;
  border-radius: 4px;
  // width: 797px;
  text-align: center;
  align-items: center;
  margin-top: 10px;
}

.desk-btn {
  background-color: #fff;
  border: none !important;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14.22px;
  font-weight: 400;
  font-family: "Voyado Text";
  // padding: 7px 19px 7px 19px;
  height: 39px;
  border-radius: 2px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  // flex: 1 0 calc(25% - 20px);
  flex: 1 0 22%;
  box-sizing: border-box;
  width: max-content;
}

.desk-btn:hover {
  background-color: #9b1c45 !important;
  border-color: #9b1c45 !important;
  color: #fff !important;
}

.desk-btn.active-btn {
  background-color: #9b1c45 !important;
  border-color: #9b1c45 !important;
  color: #fff !important;
  border-radius: 2px;
  font-family: "Voyado Text";
  padding: 10px 19px;
}

.arrow-buttons .arrow-icon {
  cursor: pointer;
}

.arrow-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.arrow-buttons .arrow-icon {
  cursor: pointer;
  background-color: #fff;
  border: none;
  height: 40px;
  width: 40px;
  box-shadow: none !important;
  outline: none !important;
}

.arrow-buttons .arrow-icon:hover {
  background-color: #fff;
  border: none;
  height: 40px;
  width: 40px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
}

@media (max-width: 800px) {
  .desk-btn {
    height: auto;
  }
}
@media (max-width: 700px) {
  .border-box {
    height: 100px;
  }
}
@media (max-width: 350px) {
  .border-box {
    height: 180px;
  }
}

@media (max-width: 800px) {
  .desk-btn {
    flex: 1 0 100%;
    height: auto;
    margin: 5px 0;
  }

  .flex-container {
    flex-direction: column;
  }

  .border-box {
    flex-direction: column;
  }
  .card1 {
    height: 150px;
  }
  .arrow-buttons {
    margin-top: 20px;
    gap: 10px;
  }
}

@media (max-width: 500px) {
  .card1 {
    height: 180px;
  }
}

//card1-css

.card1 {
  // height: 100%;
  width: 100%;
  height: 143px;
  // width: 230px;
  border-radius: 4px;
  background: #fff;
  padding: 16px;
  box-sizing: border-box;
  overflow: hidden;
  // width: max-content;
}

.card1 p {
  white-space: normal;
  overflow-wrap: break-word;
  margin: 0;
}

//graph-css
.graph {
  width: 101%;
  // width: calc(100vw - 250px);
  margin-top: 2px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.graph2 {
  padding: 0rem;
  flex: 1 1 100%; //added
}

.graphline {
  // width: 198.5px;
  height: 31.5px;
  // margin-top: 15px;
}

.card2 {
  height: 287.1px;
  border-radius: 8px;
  background: #fff;
  padding: 32px 32px 32px 32px;
  // width: 667px;
}

.card3 {
  height: 287.1px;
  border-radius: 8px;
  background: #fff;
  padding: 32px 114.4px 32px 32px;
  display: grid;
}
.graphing {
  // height: 100%;
  width: 100%;
  height: 156px;
  // width: 450px;
  margin-top: 15px;
  margin-left: 10px;
}

.text-date {
  display: flex;
  justify-content: space-between;
  font-size: 14.22px;
  line-height: 17.07px;
  font-weight: 400;
  color: #21211f;

}

.num-text {
  font-size: 36px;
  font-weight: 500;
  color: #7dbfbe;
  font-family: "Voyado Display";
  line-height: 41.56px;
  height: 42px;
  width: 91px;
  margin-top: auto;
}

.line1 {
  display: flex;
  align-items: center;
}

:deep(.liveicon) {
  background-color: #43a584 !important;
  border-radius: 20px;
  border-color: #43a584 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  margin-top: 4px !important;
}

.liveicon:hover {
  background-color: #43a584 !important;
  border-radius: 20px;
  border-color: #43a584 !important;
  width: 32px !important;
  height: 32px !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
@media (max-width: 1100px) {
  .graph {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .widget-text {
    font-size: 14px;
  }

  .num-text {
    font-size: 30px;
  }
  .p-text {
    font-size: 10px;
  }
  .graphline {
    height: 25px;
  }

  .p {
    font-size: smaller;
  }
}

@media (max-width: 400px) {
  .card3 {
    height: 235px;
    padding: 18px 114.4px 18px 18px;
  }
  .widget-text {
    font-size: 12px;
  }

  .num-text {
    font-size: 20px;
  }
  .p-text {
    font-size: 8px;
  }
  .graphline {
    height: 15px;
  }
  .p {
    font-size: 5px;
  }
  .p2-text {
    font-size: 8px;
  }
}

//dataTable-css
:deep(.p-datatable .p-datatable-thead > tr > th) {
  text-align: left;
  padding: 13px 12px;
  border: none !important;
  // border-width: 1px 0 2px 0;
  font-weight: 600;
  color: #212529;
  background: #ffffff;
  transition: box-shadow 0.15s;
}

.p-datatable .p-sortable-column .p-sortable-column-icon {
  color: #212529;
  /* margin-left: 0.5rem; */
}
.head-text {
  padding: 32px;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 91px;
  width: 100%;
  // width: 1443px;
  // width: calc(100vw - 50px);
}

.head-text1 {
  font-size: 22.78px;
  font-weight: 500;
  font-family: "Voyado Display";
  line-height: 27.34px;
  color: #21211f;
}

@media (max-width: 1100px) {
  .head-text {
    width: 100%;
  }
}

:deep(.chip) {
  width: auto;
  height: 24px;
  padding: 0px 8px 0px 8px;
  border-radius: 12px;
  font-weight: 500;
  font-size: 12.64px;
  line-height: 15.2px;
  text-align: center;
  font-family: "Voyado Text";
  /* background-color: #dff3ea; */
  background-color: rgba(67, 165, 132, 0.2);
}

:deep(.chip2) {
  width: auto;
  height: 24px;
  /* padding: 4px; */
  border-radius: 12px;
  font-weight: 500;
  font-size: 12.64px;
  line-height: 15.2px;
  text-align: center;
  font-family: "Voyado Text";
  /* background-color: #dff3ea; */
  background-color: #f0f0ef;
}

:deep(.p-column-title, .p-datatable .p-sortable-column) {
  vertical-align: middle;
  height: 15px;
  // width: auto;
  box-sizing: border-box;
  width: max-content;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  text-align: left;
  border: 1px solid #e2e2e2;
  border-width: 1px 0 0 0;
  padding: 13px 12px;
  height: 50px;
}

@media screen and (min-width: 1200px) {
  .xl\:col-12 {
    flex: 0 0 auto;
    padding: 0.5rem;
    width: -webkit-fill-available;
  }
}

.p-datatable-wrapper {
  padding: 0px;
  background: #ffffff;
  gap: 1px;
  width: 100%;
  max-height: calc(100vh - 300px);
  overflow: hidden;
}

@media screen and (min-width: 992px) {
    .lg\:col-12 {
        padding: 0px; 
        width: 100%;
    }
}
</style>
